import type { ICity } from '@/entities/common/types/city';
import type { IDoctorDetails } from '@/entities/doctor/model/types';
import type { IMedcenter } from '@/entities/medcenter/model/types';

interface GenDoctorProps {
  data: {
    doctorData?: Partial<IDoctorDetails>;
    medcenterData?: Partial<IMedcenter>;
    cityData?: Partial<ICity>;
  };
  options?: {
    hasChild?: boolean;
    hasAmbulatory?: boolean;
    hasIllnesses?: boolean;
    hasQualifications?: boolean;
  };
}

const defaultMedcenterData: IMedcenter = {
  id: 883,
  name: 'Тестовый медцентр',
  alias: '1232-testovyiy-medtsentr',
  hasOnlineBooking: true,
  hasPhones: false,
  appointments: {
    primary: { price: 0, priceWithDiscount: null, discountPercentage: null },
    secondary: { price: 0, priceWithDiscount: null, discountPercentage: null },
    online: { price: 0, priceWithDiscount: null, discountPercentage: null },
  },
  schedule: [
    {
      day: 1,
      isWork: true,
      startTime: '08:00',
      endTime: '17:00',
      is24HoursWork: false,
    },
    {
      day: 2,
      isWork: true,
      startTime: '08:00',
      endTime: '17:00',
      is24HoursWork: false,
    },
    {
      day: 3,
      isWork: true,
      startTime: '08:00',
      endTime: '17:00',
      is24HoursWork: false,
    },
    {
      day: 4,
      isWork: true,
      startTime: '08:00',
      endTime: '17:00',
      is24HoursWork: false,
    },
    {
      day: 5,
      isWork: true,
      startTime: '08:00',
      endTime: '17:00',
      is24HoursWork: false,
    },
    {
      day: 6,
      isWork: true,
      startTime: '12:00',
      endTime: '13:00',
      is24HoursWork: false,
    },
    {
      day: 7,
      isWork: false,
      startTime: null,
      endTime: null,
      is24HoursWork: false,
    },
  ],
  geo: {
    latitude: '43.235409',
    longitude: '76.899175',
    address: 'улица Таира Жарокова, 151',
    city: 'Астана',
  },
};

const defaultCityData: ICity = {
  id: 7,
  name: 'Астана',
  alias: 'astana',
};

const defaultDoctorData: IDoctorDetails = {
  id: 1224125,
  alias: '1224125-mazhenov-aybek-kuatovich',
  isBanned: false,
  isStar: true,
  isTop: false,
  isPartner: true,
  hasPhones: true,
  hasComments: true,
  hasServices: true,
  fullName: 'Маженов Тестовый',
  avatar: 'https://idoctor.kz/images/doctors/1224001/1224125/aosc3dXyg3f4vKJ7IXB6sTAZqmf6kMr5Kddp3sNx.png',
  workExperience: 1025,
  rating: 7.4,
  skills: [{ id: 2, name: 'Акушер-гинеколог', alias: 'akusher-ginekolog' }],
  qualifications: [],
  medcenters: [defaultMedcenterData],
  illnesses: [{ name: 'Ангина', alias: '68-angina' }],
  city: defaultCityData,
  ambulatory: { accept: false, price: 0 },
  child: { accept: false, age: { min: 0, max: 0 } },
  description: '',
  commentsCount: 0,
};

export const genDoctor = ({ data, options = {} }: GenDoctorProps): IDoctorDetails => {
  const { doctorData, medcenterData, cityData } = data;
  const { hasChild = true, hasAmbulatory = true, hasIllnesses = true, hasQualifications = true } = options;

  return {
    ...defaultDoctorData,
    ...doctorData,
    medcenters: [
      {
        ...defaultMedcenterData,
        ...medcenterData,
      },
    ],
    city: {
      ...defaultCityData,
      ...cityData,
    },
    child: hasChild ? doctorData?.child || defaultDoctorData.child : { accept: false, age: { min: null, max: null } },
    ambulatory: hasAmbulatory ? doctorData?.ambulatory || defaultDoctorData.ambulatory : { accept: false, price: 0 },
    illnesses: hasIllnesses ? doctorData?.illnesses || defaultDoctorData.illnesses : [],
    qualifications: hasQualifications ? doctorData?.qualifications || defaultDoctorData.qualifications : [],
  };
};
